export default "__VITE_ASSET__DooPuz8j__"